import * as React from "react";

function SvgPa(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 512 336"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M503.172 335.724H8.828A8.829 8.829 0 010 326.896V9.103A8.829 8.829 0 018.828.275h494.345a8.829 8.829 0 018.828 8.828v317.793a8.83 8.83 0 01-8.829 8.828z"
          fill="#F5F5F5"
        />
        <path
          d="M256 168h247.172a8.829 8.829 0 008.828-8.828V9.103a8.829 8.829 0 00-8.828-8.828H264.828A8.829 8.829 0 00256 9.103V168z"
          fill="#FF4B55"
        />
        <path
          d="M8.828 335.724h238.345a8.829 8.829 0 008.828-8.828V168H8.828A8.829 8.829 0 000 176.828v150.069a8.828 8.828 0 008.828 8.827zM131.4 46.487l8.416 25.234 26.6.206c3.444.026 4.872 4.422 2.101 6.467l-21.398 15.801 8.023 25.362c1.038 3.284-2.7 5.999-5.502 3.997L128 108.087l-21.641 15.468c-2.802 2.003-6.54-.714-5.502-3.997l8.023-25.362-21.398-15.801c-2.771-2.046-1.343-6.441 2.101-6.467l26.6-.206 8.416-25.234c1.09-3.268 5.712-3.268 6.801-.001z"
          fill="#4173CD"
        />
        <path
          d="M387.4 214.211l8.416 25.234 26.6.206c3.444.026 4.872 4.422 2.101 6.467l-21.398 15.801 8.023 25.362c1.038 3.284-2.7 5.999-5.502 3.997L384 275.811l-21.641 15.468c-2.802 2.003-6.54-.714-5.502-3.997l8.023-25.362-21.398-15.801c-2.771-2.046-1.343-6.441 2.101-6.467l26.6-.206 8.416-25.234c1.09-3.268 5.712-3.268 6.801-.001z"
          fill="#FF4B55"
        />
      </g>
    </svg>
  );
}

export default SvgPa;
